import React, { useState } from "react";
import dhyanaService from "../services/dhyanaService";

interface EmailSignupProps {
  persona: string; // persona key (e.g. "medium_balanced")
}

const EmailSignup: React.FC<EmailSignupProps> = ({ persona }) => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "sending" | "ok" | "err">(
    "idle",
  );

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setStatus("sending");
    try {
      // dhyanaService.submitSignup expects (email, persona) as separate params
      await dhyanaService.submitSignup(email, persona);
      setStatus("ok");
      setEmail(""); // Clear form on success
    } catch (error) {
      console.error("Email signup failed:", error);
      setStatus("err");
    }
  };

  return (
    <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white py-16">
      <div className="container mx-auto px-6 text-center">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-3xl lg:text-4xl font-bold mb-6">
            Ready to Transform Your Marketing Intelligence?
          </h2>
          <p className="text-xl mb-8 opacity-90">
            Join thousands of marketing professionals who get actionable
            insights every Monday.
          </p>

          <form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto"
          >
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              className="flex-1 px-4 py-3 rounded-lg text-gray-900 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-white focus:border-transparent"
              disabled={status === "sending"}
              required
            />
            <button
              type="submit"
              disabled={status === "sending" || !email.trim()}
              className="bg-white text-blue-600 px-8 py-3 rounded-lg font-bold hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {status === "sending" ? "Subscribing..." : "Subscribe"}
            </button>
          </form>

          {/* Status messages */}
          {status === "ok" && (
            <div className="mt-4 p-4 bg-green-100 text-green-800 rounded-lg">
              Thanks for subscribing! Check your email for confirmation.
            </div>
          )}

          {status === "err" && (
            <div className="mt-4 p-4 bg-red-100 text-red-800 rounded-lg">
              Something went wrong. Please try again or contact support.
            </div>
          )}

          <p className="text-sm opacity-75 mt-4">
            Weekly insights • No spam • Unsubscribe anytime
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmailSignup;
